import React from 'react';
import moment from 'moment-timezone';
import Kronos from '@locus-taxy/react-kronos';
import theme from 'common/components/core/form/Kronos.scss';
import { compose } from 'recompose';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { SizeEnum } from 'common/enums/UIEnums';

class KronosYearPicker extends Kronos {
    setState(state) {
        //hack to avoid changing level on selection of date
        super.setState({ ...state, level: 'years' });
    }

    onSelect(datetime, close, timeUnit) {
        //hack to force close the date picker when a year is selected
        if (close === false) {
            super.onSelect(datetime, true, timeUnit);
        } else {
            super.onSelect(datetime, close, timeUnit);
        }
    }

    onKeyDown(code) {
        //fixing improper logic of keydown in library and also cusomizing it for years
        const { input, visible } = this.state;

        // Some components were passing state.datetime as 'null', so need to handle it explicitly.
        let { datetime } = this.state;
        if (!datetime) datetime = moment();

        const Keys = {
            ENTER: 13,
            ESC: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };
        switch (code) {
            case Keys.UP:
                this.onSelect(datetime.subtract(3, 'year'));
                break;
            case Keys.DOWN:
                this.onSelect(datetime.add(3, 'year'));
                break;
            case Keys.LEFT:
                this.onSelect(datetime.subtract(1, 'year'));
                break;
            case Keys.RIGHT:
                this.onSelect(datetime.add(1, 'year'));
                break;
            case Keys.ENTER:
                if (input === datetime.format(this.format())) {
                    if (!this.validate(datetime)) {
                        this.toggle(true);
                    } else {
                        this.toggle();
                    }
                } else {
                    const parsedDatetime = this.parse(input);
                    if (!visible) {
                        this.toggle(true);
                    }
                    if (parsedDatetime) {
                        this.save(parsedDatetime);
                    }
                }
                break;
        }
    }
}

class YearPicker extends React.PureComponent {
    onChangeHandler = value => {
        const { onChange } = this.props;
        onChange(value?.year());
    };

    render() {
        const { value, theme, testId, className, ...others } = this.props;
        const sizeClass = SizeEnum.getSizeClass({
            theme,
            size: SizeEnum.Small
        });

        return (
            <div
                className={classnames(
                    theme.dateTimeWrap,
                    theme.fullWidth,
                    sizeClass,
                    className
                )}
            >
                <KronosYearPicker
                    inputId={testId}
                    date={value}
                    max={moment()}
                    theme={theme}
                    preventClickOnDateTimeOutsideRange
                    onChangeDateTime={this.onChangeHandler}
                    format="YYYY"
                    className={theme.date}
                    closeOnBlur
                    {...others}
                />
            </div>
        );
    }
}

const ThemedYearPicker = compose(themr('YearPicker', theme))(YearPicker);
export { ThemedYearPicker as YearPicker };
export default ThemedYearPicker;
